module.exports = __webpack_public_path__ + "img/logout-icon.fbe75c20.svg";